export enum Gender {
  Male = "male",
  Female = "female",
  Other = "other",
  PreferNotToSay = "prefer not to say",
}

export enum UserType {
  Member = "member",
  Coach = "coach",
  Staff = "staff",
}

export enum Status {
  Active = "active",
  Inactive = "inactive",
}

export enum UserStatus {
  Pending = "pending",
  Active = "active",
  Inactive = "inactive",
}

export enum ExerciseType {
  TimeBased = "Time Based",
  RepetitionBased = "Repetition Based",
}


export enum ExerciseIntensity {
  MaxIntensity = "Max Intensity",
  Irm = "irm",
}


export enum ExerciseDifficulty {
  Novice = 0,
  Beginner,
  Intermediate,
  Advance,
  Expert,
}

export enum SaleStatus {
  Sale = "Sale",
  Refund = "Refund",
}

export enum TransactionType {
  Paid = "Paid",
  Unpaid = "Unpaid",
}

export enum MembershipStatus {
  active = "active",
  inactive = "inactive",
}

export enum CreditType {
  amount = "amount",
  unlimited = "unlimited",
}

export enum InvoiceType {
  Proforma = "Proforma",
  Invoice = "Invoice",
}

export enum InvoiceStatus {
  Paid = "Paid",
  Pending = "Pending",
  Cancelled = "Cancelled",
  Refunded = "Refunded",
  Processing = "Processing",
}

export enum TaxType {
  inclusive = "inclusive",
  exclusive = "exclusive",
}

export enum ProductStatus {
  Pending = "Pending",
  Paid = "Paid",
  Failed = "Failed",
  Cancelled = "Cancelled",
  Refunded = "Refunded",
  PartiallyRefund = "Partially Refund",
}

export enum POSProductType {
  Event = "events",
  Membership = "membership_plans",
  Product = "products",
  Facilities = "facilities",
  CreditAddOns = "credit_add_ons",
  TrainingPackage = "training_package",
}


export enum ComparisonCondition {
  GreaterThan = "Greater than",
  LessThan = "Less than",
  EqualTo = "Equal to"
}

export enum BookingType {
  Public = "Public",
  MemberOnly = "Member Only",
}

export enum FacilityAddOnType {
  Inclusive = "inclusive",
  Exclusive = "exclusive"
}

export enum FacilityStatus {
  Active = "active",
  Inactive = "inactive"
}

export enum ConsultationStatus {
  Draft = "draft",
  AwaitingApproval = "awaiting_approval",
  Approved = "approved",
  Scheduled = "scheduled",
  Completed = "completed",
  Rejected = "rejected",
  Pending = "pending",
}


export enum Difficulty {
  Novice = "Novice",
  Beginner = "Beginner",
  Intermediate = "Intermediate",
  Advanced = "Advanced",
  Expert = "Expert",
}

export enum Intensity {
  max_intensity = "Max Intensity",
  irm = "irm",
}


export enum Visibility {
  OnlyMyself = "Only Myself",
  StaffOfMyClub = "Staff of My Club",
  MembersOfMyClub = "Members of My Club",
  EveryoneInMyClub = "Everyone in My Club",
}

export enum DifficultySlider {
  Novice = 0,
  Beginner,
  Intermediate,
  Advance,
  Expert,
}


export enum TransactionStatus {
  Paid = "Paid",
  Unpaid = "Unpaid",
  Pending = "Pending",
  // Partially_Paid = "Partially Paid",
}


export enum RevenueType {
  Donation = "donation",
  Income = "income",
}

export enum EventBookingType {
  FullyBooked = "fully_booked",
  PartiallyBooked = "partially_booked",
}

export enum EventStatus {
  Upcoming = "upcoming",
  Ongoing = "ongoing",
  Completed = "completed",
}

export enum FacilityType {
  Default = "default",
  Trainer = "trainer",
  Consultation = "consultation",
}

export enum MembershipType {
  CreditAddOns = "credit_add_ons",
  Default = "default",
}

export enum SaleTaxType {
  SRB = 'srb',
  Other = 'other'
}

export enum TaxGroupType {
  Member = "member",
  Item = "item",
}